import gql from 'graphql-tag';

export default gql`
  query listConditions(
    $appId: String!
    $environment: String!
    $featureKey: String!
    $conditionType: ConditionType!
  ) {
    listConditions(
      filter: {
        appId: $appId
        environment: $environment
        featureKey: $featureKey
        conditionType: $conditionType
      }
    ) {
      items {
        appId
        environment
        featureKey
        conditionType
        conditionRule
        conditionTarget
        enable
        createAt
        uId
      }
    }
  }
`;

const gqlQrylistCondsWithMultiConditionType = gql`
  query listConditionsWithMultiConditionTypes(
    $appId: String!
    $environment: String!
    $featureKey: String!
    $conditionType: [ConditionType]!
  ) {
    listConditionsWithMultiConditionTypes(
      filter: {
        appId: $appId
        environment: $environment
        featureKey: $featureKey
        conditionType: $conditionType
      }
    ) {
      items {
        appId
        environment
        featureKey
        conditionType
        conditionRule
        conditionTarget
        enable
        createAt
        uId
      }
    }
  }
`;
export { gqlQrylistCondsWithMultiConditionType };
